import { render, staticRenderFns } from "./NoticeRemoveLawyerParty.vue?vue&type=template&id=4864e1e1"
import script from "./NoticeRemoveLawyerParty.vue?vue&type=script&lang=ts"
export * from "./NoticeRemoveLawyerParty.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports